import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RawProgressButton from 'react-progress-button';

class ProgressButton extends Component {
	shouldComponentUpdate = ({ state, text }) => {
		const lastProps = this.props;

		return (
			state !== lastProps.state
			|| text !== lastProps.text
		);
	}

	render() {
		const {
			state,
			type,
			className,
			text,
			onClick,
		} = this.props;

		return (
			<RawProgressButton
				type={type}
				className={className}
				state={state}
				onClick={onClick}
			>
				{ text }
			</RawProgressButton>
		);
	}
}

ProgressButton.propTypes = {
	text      : PropTypes.string.isRequired,
	state     : PropTypes.string.isRequired,
	type      : PropTypes.string.isRequired,
	className : PropTypes.string,
	onClick   : PropTypes.func,
};

ProgressButton.defaultProps = {
	className : '',
	onClick   : () => {},
};

export default ProgressButton;
